export const THEME = {
	COLORS: {
		PRIMARY: "#4EA233",
		PRIMARY25: "#E8F5E8",

		INFO: "#0081A4",

		CLASSIC_PRIMARY: "#009EF7",
	},
};
